/**
 * Token utility functions
 */

/**
 * Check if a JWT token is valid (not expired)
 */
export function isTokenValid(token: string): boolean {
  if (!token) return false
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    const now = Math.floor(Date.now() / 1000)
    return payload.exp && payload.exp > now
  } catch (error) {
    return false
  }
}

/**
 * Clear expired tokens from localStorage
 */
export function clearExpiredTokens(): void {
  const token = localStorage.getItem('token')
  if (token && !isTokenValid(token)) {
    localStorage.removeItem('token')
    console.log('🧹 Cleared expired token from localStorage')
  }
}

/**
 * Get valid token from localStorage (returns null if expired)
 */
export function getValidToken(): string | null {
  // First try the bgai-auth-storage (primary storage used by auth system)
  try {
    const storedState = localStorage.getItem('bgai-auth-storage')
    if (storedState) {
      const parsed = JSON.parse(storedState)
      const token = parsed.state?.token
      if (token && isTokenValid(token)) {
        // Silent success - no need to log every time
        return token
      }
    }
  } catch (error) {
    console.warn('Failed to parse bgai-auth-storage:', error)
  }
  
  // Fallback to direct token storage
  const token = localStorage.getItem('token')
  if (token && isTokenValid(token)) {
    // Silent success - no need to log every time
    return token
  }
  
  // Don't log warning if user is logged out (no auth storage exists)
  const hasAuthStorage = localStorage.getItem('bgai-auth-storage')
  const hasDirectToken = localStorage.getItem('token')
  
  // Only warn if there's some auth data but it's invalid (not during normal logout)
  if (hasAuthStorage || hasDirectToken) {
    console.warn('🔑 No valid token found during getValidToken()')
  }
  
  return null
}